import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import admin from './admin';
import auth from './auth';
import flags from './flags';
import design from './design';
import basket from './basket';
import checkout from './checkout';
import dashboard from './dashboard';
import cta from './cta';
import addresses from './addresses';
import onboard from './onboard';
import personalInfo from './personalInfo';
import invite from './invite';
import libraries from './libraries';
import join from './join';
import products from './products';
import approval from './approval';
import vouchers from './vouchers';
import uploads from "./uploads";

import {waitPlugin} from './wait';
let plugins = [waitPlugin];

// Uncomment to log during development or test debugging:
//import createLogger from 'vuex/dist/logger'
//plugins.push([createLogger()]);

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
plugins.push(createPlugin(LogRocket));

export default new Vuex.Store({
  plugins,
  modules: {
    admin, auth, flags, design, basket, checkout, dashboard, cta,
    addresses, onboard, personalInfo, invite, libraries, join,
    products, approval, vouchers, uploads,
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js